import { gql } from '@apollo/client';

export const TRANSLATE_FLYER_MUTATION = gql`
  mutation translateFlyer($input: TranslateFlyerInput!) {
    translateFlyer(input: $input) {
      translatedWcag
    }
  }
`;
